import {ReportGroupingLevel} from '../../../constants'
import messageResource from '../../../../messageResource'

export default class BillingSummaryCSVPreviewUtils {
    static addGroupingLevelsCells = (row, firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, useEmptyCommentsCell, needOthers) => {
        if (firstGroupingLevel !== ReportGroupingLevel.NONE) {
            let levelPreviewName
            if (firstGroupingLevel === ReportGroupingLevel.USER && needOthers) {
                levelPreviewName = messageResource.getMessage("report.common.others")
            } else {
                levelPreviewName = ReportPreviewUtils.getLevelPreviewName(firstGroupingLevel)
            }
            ReportPreviewUtils.addCell(row, levelPreviewName)
        }
        if (secondGroupingLevel !== ReportGroupingLevel.NONE) {
            let levelPreviewName
            if (secondGroupingLevel === ReportGroupingLevel.USER && needOthers) {
                levelPreviewName = messageResource.getMessage("report.common.others")
            } else {
                levelPreviewName = ReportPreviewUtils.getLevelPreviewName(secondGroupingLevel)
            }
            ReportPreviewUtils.addCell(row, levelPreviewName)
        }
        if (thirdGroupingLevel !== ReportGroupingLevel.NONE) {
            if (thirdGroupingLevel === ReportGroupingLevel.TASK_AND_TT_COMMENTS
                || thirdGroupingLevel === ReportGroupingLevel.PROJECT_AND_TT_COMMENTS
                || thirdGroupingLevel === ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS)
            {
                if (thirdGroupingLevel === ReportGroupingLevel.TASK_AND_TT_COMMENTS)
                    ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(ReportGroupingLevel.TASK))
                if (thirdGroupingLevel === ReportGroupingLevel.PROJECT_AND_TT_COMMENTS)
                    ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(ReportGroupingLevel.PROJECT))
                if (thirdGroupingLevel === ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS)
                    ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(ReportGroupingLevel.CUSTOMER))
                ReportPreviewUtils.addCell(
                    row,
                    useEmptyCommentsCell ? "" : ReportPreviewUtils.getLevelPreviewName(ReportGroupingLevel.TT_COMMENTS)
                )
            }
            else {
                ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(thirdGroupingLevel))
            }
        }
    }

    static getNumberOfGroupingLevelsCells = (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel) => {
        let numberOfGroupingLevelsCells = ReportPreviewUtils.countNotEmptyLevels([
            firstGroupingLevel,
            secondGroupingLevel,
            thirdGroupingLevel
        ])
        if (thirdGroupingLevel === ReportGroupingLevel.TASK_AND_TT_COMMENTS
            || thirdGroupingLevel === ReportGroupingLevel.PROJECT_AND_TT_COMMENTS
            || thirdGroupingLevel === ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS) {
            numberOfGroupingLevelsCells++
        }
        return numberOfGroupingLevelsCells
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewUtils.js